<template>
  <v-content>
    <OLoadingDialog :value="isLoading" />

    <v-toolbar
      flat
      style="position: relative: z-index: 2"
      v-if="row != null"
      color="grey lighten-2"
    >
      <v-icon>developer_board</v-icon>
      <v-flex xs4>
        <v-toolbar-title class="ml-4">
          {{ clientLabel }}
        </v-toolbar-title>
      </v-flex>
      <v-flex xs8>
        <v-tabs
          centered
          background-color="transparent"
          color="primary"
          v-model="currentTab"
        >
          <v-tab
            v-for="t in [
              { value: '#parsed', label: 'Rawdata (parsed)' },
              { value: '#hex', label: 'Rawdata (hex)' },
              { value: '#handshake', label: 'Handshake' },
              { value: '#json', label: 'JSON' }
            ]"
            :key="t.value"
            :href="t.value"
            :class="{ 'grey--text text--darken-1': t.beta }"
          >
            {{ t.label }}
          </v-tab>
        </v-tabs>
      </v-flex>
    </v-toolbar>

    <div
      v-if="row != null"
      style="max-height: calc(100vh - 128px)"
      class="d-flex fill-width fill-height align-stretch pa-2"
    >
      <div
        class="flex-grow-0 flex-shrink-0 pa-2 max-height"
        style="width: 400px;"
      >
        <v-card class="fill-height scroll-y">
          <div style="height: 300px; position: relative">
            <HeartbeatsMap :heartbeats="[row]" :highlighted="row" />
          </div>
          <v-card-text class="h-row flex-wrap pa-3 children-pa-3">
            <div
              class="cap-cont"
              v-for="d of mainDetails"
              :key="d.label"
              :class="`oderon-col-${d.size || 12}`"
            >
              <label>{{ d.label }}</label>
              <p>
                <span v-if="d.href == null">{{ d.value || '-' }}</span>
                <router-link v-else :to="d.href">{{ d.value }}</router-link>
              </p>
            </div>

            <div class="oderon-col-12">
              <HeartbeatFlags :hb="row" />
            </div>
          </v-card-text>
          <div class="h-row pa-3">
            <v-btn @click="navigate('prev')">Anterior</v-btn>
            <v-spacer />
            <v-btn @click="navigate('next')">Próximo</v-btn>
          </div>
        </v-card>
      </div>
      <div class="flex-grow-1 pa-2 scroll-y">
        <v-tabs-items v-model="currentTab" v-if="row != null">
          <v-tab-item value="parsed">
            <HeartbeatRawdata :hb="row" />
          </v-tab-item>

          <v-tab-item value="hex">
            <pre>{{ strRawdata | prettyRawdata }}</pre>
          </v-tab-item>

          <v-tab-item value="handshake">
            <pre>{{ handshake | prettyJson }}</pre>
          </v-tab-item>

          <v-tab-item value="json">
            <pre>{{ row | prettyJson }}</pre>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </v-content>
</template>

<script>
import _ from 'lodash'
import { Heartbeat } from '@/models'
import { dt } from 'oderon-commons/src/formatters'
import HeartbeatsMap from '../../components/heartbeats/map/HeartbeatsMap.vue'

function dh(x) {
  let hex = _.padStart(x.toString(16), 4, '0')
  return `${x} (0x${hex})`
}

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    HeartbeatRawdata: require('./HeartbeatRawdata').default,
    HeartbeatsMap,
    HeartbeatFlags: require('./HeartbeatFlags.vue').default
  },
  props: {
    hbid: {} // setado pelo vue-router
  },
  data() {
    return { isLoading: true, currentTab: 'parsed', row: null }
  },
  computed: {
    clientLabel() {
      let c = this.row.client
      if (c == null) return '-'

      let v = _.get(c, 'vehicle.code') || '(s/placa)'
      return `${v} ─ ${c.id}`
    },
    summary() {
      return this.row.summary || {}
    },
    mainDetails() {
      return [
        { label: 'ID', value: `${this.row.id} (${this.summary.reqId})` },
        {
          label: 'Organização',
          value: this.row.client.organization.name,
          href: `/orgs/${this.row.client.organizationId}`,
          size: 6
        },
        {
          label: 'Módulo',
          value: this.row.clientId,
          href: `/clients/${this.row.clientId}`,
          size: 6
        },
        {
          label: 'HB recebido em',
          value: dt(this.row.receivedOn, 'DD/MMM/YYYY HH:mm:ss Z')
        },
        { label: 'FW Version', value: dh(this.row.firmwareVersion), size: 6 },
        { label: 'Lote', value: this.row.client.batchNumber, size: 6 }
      ]
    },
    strRawdata() {
      let m = _.find(this.row.measures, { measureType: 'raw_data' })
      return m == null ? '-' : m.rawContents
    },
    handshake() {
      let m = _.find(this.row.measures, { measureType: 'handshake' })
      return m == null ? null : m.jsonContents
    }
  },
  mounted() {
    this.reload()
  },
  watch: {
    hbid() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let row = await Heartbeat.findById(this.hbid)
      this.row = row
    },

    async navigate(dir) {
      await this.$loading(async () => {
        let nextId = await this.fetchNextId(dir)

        if (nextId == null) {
          this.$snack('Não há mais heartbeats nessa direção.')
        } else {
          this.$router.push(`/heartbeats/${nextId}`)
        }
      })
    },

    // Retorna o id do próximo heartbeat na direção
    // escolhida, ou null se não existir.
    async fetchNextId(dir) {
      let params = {
        clientId: this.row.clientId,
        limit: 2,
        order: 'receivedOn ' + (dir == 'next' ? 'ASC' : 'DESC')
      }

      if (dir == 'next') {
        params.fromHeartbeat = this.row.id
      } else {
        params.untilHeartbeat = this.row.id
      }

      let data = await Heartbeat.findAll(params)
      if (data.rows.length < 2) return null
      else return data.rows[1].id
    }
  },
  filters: {
    prettyRawdata(str) {
      let max = 32 * 2
      let n = Math.ceil(str.length / max)
      let result = _.times(n, i => str.substr(i * max, max))
      return result.join('\n')
    }
  }
}
</script>

<style></style>
